/**
 * Created by Jie Gao on 12/05/2020.
 */
import {HorribleHeroesReelSymbol} from "./HorribleHeroesReelSymbol";
import {SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";


export class HorribleHeroesSymbolL extends HorribleHeroesReelSymbol {

    public adjustSize(symbolH: number, symId: number, duration: number = 0.17): TimelineLite | void {
        const scale = symbolH / 147;
        const tl = new TimelineLite();
        if (this._bg)
            tl.to(this._bg.scale, duration, {y: scale}, 0);
        if (this._symImage) {
            tl.to(this._symImage.scale, duration, {x: scale, y: scale}, 0);
        }
        tl.to(this, duration, {
            y: ((symId) * symbolH) + (symbolH / 2)
        }, 0);
        return tl;
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if (this._winFireAnimation) {
            this._winFireAnimation.hide();
            this._winFireAnimation.stopLoop();
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.win.keyword) {
            if (!this._winFireAnimation) {
                this.addWinFire();
            }
            this._winFireAnimation.tint = 0xe65c00;
            this.addChild(this._winFireAnimation);
            timeline.add([
                this._winFireAnimation.getAnimationAutoShowHide(true, true)
            ], delay);
        }
    }
}